import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import ComplaintButton from 'generic/ComplaintButton';
import { useStores } from 'hooks/useStores';
import EditButton from 'generic/ActionButtons/EditButton';
import ArchiveButton from 'generic/ActionButtons/ArchiveButton';
import RestoreButton from 'generic/ActionButtons/RestoreButton';
import PublicationDate from '../PublicationDate';
import { InfoContainer, ActionButtonsContainer, Complaint } from './PublicationInfoStyles';
import ViewsCount from '../ViewsCount';

const PublicationInfo = observer(() => {
  const {
    advertsStore: { currentAdvert, updateCurrentAdvert },
    profileStore: { isUser },
  } = useStores();

  const [isOpenedPopover, setOpenedPopover] = useState(false);

  // TODO: sorry, it was fast and cheap
  const location = currentAdvert.proposal_type
    ? `proposals-${currentAdvert.proposal_type}`
    : currentAdvert.advert_type;

  const onArchiveCallback = () => {
    updateCurrentAdvert();
    setOpenedPopover(false);
  };

  return currentAdvert?.is_owner ? (
    <ActionButtonsContainer>
      {currentAdvert.status === 'active' && (
        <>
          <EditButton advert={currentAdvert} className="on-truck-page" primary />
          <ArchiveButton
            location={location}
            advert={currentAdvert}
            className="on-truck-page"
            callback={onArchiveCallback}
            isOpenedPopover={isOpenedPopover}
            setOpenedPopover={setOpenedPopover}
          />
        </>
      )}
      {currentAdvert.status === 'archived' && (
        <RestoreButton
          advert={currentAdvert}
          className="on-truck-page"
          callback={updateCurrentAdvert}
        />
      )}
    </ActionButtonsContainer>
  ) : (
    <InfoContainer>
      <PublicationDate className="right-column" />
      <ViewsCount />
      {isUser && (
        <Complaint>
          <ComplaintButton gray transportUrl={currentAdvert?.url} children="Жалоба" />
        </Complaint>
      )}
    </InfoContainer>
  );
});

export default PublicationInfo;
